function parsePageModel(page) {
  const pageModel = page?.toJSON() || {};
  return pageModel;
}
export {
  parsePageModel
};
//# sourceMappingURL=parse-page-model.js.map
